export enum UserProfil {
  Diffus = 'mnt_diffus',
  Mnt = 'mnt',
  CRTLecture = 'crt_lecture',
  CRTLectureEcriture = 'crt_lecture_ecriture',
  Admin = 'admin',
  BackofficeLecture = 'backoffice_lecture',
  BackofficeLectureEcriture = 'backoffice_lecture_ecriture',
  IoT = 'iot',
  SuperAdmin = 'super_admin',
  Travaux = 'travaux',
  Magasinier = 'magasinier',
}
